import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { getSector } from '../data/sectorsData';

// Representative client wordmarks across sectors (placeholders — swap for real
// client logos when available).
const LOGOS = [
  'Meridian Co-op Bank',
  'Cygnus Digital',
  'Apex Manufacturing',
  'Nova Health',
  'Sentinel Facility Services',
  'Brightpath Talent',
  'Grand Meridian Hotels',
  'Aegis Assurance',
];

// Testimonials drawn from three different sectors to reinforce breadth.
const PICKS = ['banking-nbfc', 'security-manpower', 'corporate-staffing'];

const SocialProof = () => {
  const testimonials = PICKS.map((s) => getSector(s)?.testimonial).filter(Boolean);

  return (
    <section id="proof" className="pt-12 lg:pt-16 pb-20 lg:pb-28 bg-white border-t border-brand-ink/10">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-14">
        {/* Logos strip */}
        <div className="text-center mb-4">
          <div className="eyebrow inline-flex items-center" data-testid="proof-eyebrow">
            <span className="inline-block w-8 h-px bg-brand-ink/40 mr-3 align-middle" />
            Trusted by teams across every sector
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-5 py-8 border-y border-brand-ink/10 mb-16" data-testid="proof-logos">
          {LOGOS.map((name, i) => (
            <div key={i} className="flex items-center gap-2 text-brand-ink/60 hover:text-brand-ink transition-colors">
              <span className="w-2 h-2 rounded-sm bg-brand-orange/70 rotate-45" />
              <span className="font-display font-medium text-base lg:text-lg tracking-tight whitespace-nowrap">{name}</span>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
          {testimonials.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.5, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="flex flex-col bg-brand-cream border border-brand-ink/10 rounded-md p-6 lg:p-7"
              data-testid={`proof-testimonial-${i + 1}`}
            >
              <Quote className="w-7 h-7 text-brand-orange/30 mb-4" />
              <blockquote className="text-base text-brand-ink/80 leading-relaxed flex-1 text-pretty">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-brand-ink/10 flex items-center gap-3">
                <span className="w-9 h-9 rounded-full bg-brand-navy text-white flex items-center justify-center font-display font-medium flex-shrink-0">
                  {t.company.charAt(0)}
                </span>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-brand-ink truncate">{t.name}</div>
                  <div className="text-xs text-brand-ink/50 truncate">{t.role} · {t.company}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
